import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { BrandMark } from './BrandMark';

const navigation = [
  { to: '/workspace', label: 'Workspace' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/support', label: 'Support' },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <BrandMark />
        <button
          type="button"
          className="menu-button"
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
          <span className="sr-only">Toggle navigation</span>
        </button>
        <nav id="primary-navigation" className={`primary-nav${open ? ' primary-nav--open' : ''}`} aria-label="Primary navigation">
          {navigation.map((item) => (
            <NavLink key={item.to} to={item.to} onClick={() => setOpen(false)}>
              {item.label}
            </NavLink>
          ))}
          <Link className="button button--small button--ink" to="/workspace" onClick={() => setOpen(false)}>
            Open workspace
          </Link>
        </nav>
      </div>
    </header>
  );
}
